import { Enviroment } from '../../../../../../_config/constants/enviroment-v2.constant';
import { typeRetirement } from '../constants/type-retirement.constant';
import { checkStatusReverse } from './check-status-reverse.handle';

export const getStatusNumber = (typeDelivery, products) => {
	return {
		AR: {
			1: 'Antes de aprobar la orden y continuar, verifica la receta. Podés rechazarla en caso de error y solicitar que se reenvíe correctamente.',
			101: 'Al menos una receta presentó inconvenientes. Si ya fue regularizado por el cliente, aprobá la orden para continuar.',
			2: `¡Tenés un nuevo pedido! Dale a continuar para comenzar el proceso.`,
			201: 'Antes de continuar verificá que cuentes con el stock de los productos. En caso  de un faltante contáctate con el cliente para ofrecerle una solución.',
			3: 'Ya podés armar la orden. Asegúrate de tener el pedido armado antes de continuar, ya que se notificará que está listo para su retiro.',
			4: 'En caso de retiro en tienda: Ya se le notificó al cliente que el paquete ya está listo para retirar. De ser envío a domicilio: Ya se le avisó a la moto para que retire el paquete.',
			5: `La moto ya retiró el paquete y se encuentra en camino al domicilio de entrega.`,
			6: 'El pedido fue entregado.',
			8: 'El pedido fue cancelado y se le devolvió el dinero al cliente.',
			9: 'El cliente confirmó la entrega del pedido.',
		},

		CL: {
			1: 'Antes de aprobar la orden y continuar, verifica la receta. Podés rechazarla en caso de error y solicitar que se reenvíe correctamente.',
			101: 'Al menos una receta presentó inconvenientes. Si ya fue regularizado por el cliente, aprobá la orden para continuar.',
			2: `La orden fue aprobada. Si necesitas realizar algún cambio, puedes hacerlo desde aquí o continuar.`,
			201: 'Verifica que cuentes con todos los productos que contiene la orden. Si necesitas anular algún producto o la totalidad de la orden, puedes hacerlo desde aquí o continuar.',
			3: 'La orden fue confirmada y ya puedes empacar el pedido. En cuanto esté listo, dale a continuar.',
			4: `${
				typeDelivery === typeRetirement[Enviroment.LANGUAGE].home
					? 'El pedido ya fue armado y está listo para ser retirado por el mensajero.'
					: 'El pedido ya fue armado y está listo para ser retirado por el cliente. Cuando el cliente retire el pedido confirma la entrega.'
			}`,
			5: `El pedido ya fue entregado al mensajero y se encuentra en camino al domicilio del cliente.`,
			6: `${
				typeDelivery === typeRetirement[Enviroment.LANGUAGE].home
					? 'El pedido fue entregado en el domicilio del cliente.'
					: 'El pedido fue entregado al cliente en la farmacia.'
			}`,
			8: `${
				checkStatusReverse(products)
					? 'El pedido fue anulado. En caso de ser necesario puedes revertir la anulación'
					: 'El pedido fue anulado. Esta orden no tiene productos, no se puede revertir la anulación de la orden.'
			}`,
			9: 'El cliente ha confirmado la entrega/recepción del pedido.',
		},
		CLNARMA: {
			1: 'Antes de aprobar la orden y continuar, verifica la receta. Podés rechazarla en caso de error y solicitar que se reenvíe correctamente.',
			101: 'Al menos una receta presentó inconvenientes. Si ya fue regularizado por el cliente, aprobá la orden para continuar.',
			2: `La orden fue aprobada. Si necesitas realizar algún cambio, puedes hacerlo desde aquí o continuar.`,
			201: 'Verifica que cuentes con todos los productos que contiene la orden. Si necesitas anular algún producto o la totalidad de la orden, puedes hacerlo desde aquí o continuar.',
			3: 'La orden fue confirmada y ya puedes empacar el pedido. En cuanto esté listo, dale a continuar.',
			4: `${
				typeDelivery === typeRetirement[Enviroment.LANGUAGE].home
					? 'El pedido ya fue armado y está listo para ser retirado por el mensajero. Cuando el cliente reciba el pedido confirma la entrega.'
					: 'El pedido ya fue armado y está listo para ser retirado por el cliente. Cuando el cliente retire el pedido confirma la entrega.'
			}`,
			5: `El pedido ya fue entregado al mensajero y se encuentra en camino al domicilio del cliente.`,
			6: `${
				typeDelivery === typeRetirement[Enviroment.LANGUAGE].home
					? 'El pedido fue entregado en el domicilio del cliente.'
					: 'El pedido fue entregado al cliente en la farmacia.'
			}`,
			8: `${
				checkStatusReverse(products)
					? 'El pedido fue anulado. En caso de ser necesario puedes revertir la anulación'
					: 'El pedido fue anulado. Esta orden no tiene productos, no se puede revertir la anulación de la orden.'
			}`,
			9: 'El cliente ha confirmado la entrega/recepción del pedido.',
		},
		CLANICX: {
			1: 'Antes de aprobar la orden y continuar, verifica la receta. Podés rechazarla en caso de error y solicitar que se reenvíe correctamente.',
			101: 'Al menos una receta presentó inconvenientes. Si ya fue regularizado por el cliente, aprobá la orden para continuar.',
			2: `La orden fue aprobada. Si necesitas realizar algún cambio, puedes hacerlo desde aquí o continuar.`,
			201: 'Verifica que cuentes con todos los productos que contiene la orden. Si necesitas anular algún producto o la totalidad de la orden, puedes hacerlo desde aquí o continuar.',
			3: 'La orden fue confirmada y ya puedes empacar el pedido. En cuanto esté listo, dale a continuar.',
			4: `${
				typeDelivery === typeRetirement[Enviroment.LANGUAGE].home
					? 'El pedido ya fue armado y está listo para ser retirado por el mensajero. Cuando el cliente reciba el pedido confirma la entrega.'
					: 'El pedido ya fue armado y está listo para ser retirado por el cliente. Cuando el cliente retire el pedido confirma la entrega.'
			}`,
			5: `El pedido ya fue entregado al mensajero y se encuentra en camino al domicilio del cliente.`,
			6: `${
				typeDelivery === typeRetirement[Enviroment.LANGUAGE].home
					? 'El pedido fue entregado en el domicilio del cliente.'
					: 'El pedido fue entregado al cliente en la farmacia.'
			}`,
			8: `${
				checkStatusReverse(products)
					? 'El pedido fue anulado. En caso de ser necesario puedes revertir la anulación'
					: 'El pedido fue anulado. Esta orden no tiene productos, no se puede revertir la anulación de la orden.'
			}`,
			9: 'El cliente ha confirmado la entrega/recepción del pedido.',
		},
		CLGREEN: {
			1: 'Antes de aprobar la orden y continuar, verifica la receta. Podés rechazarla en caso de error y solicitar que se reenvíe correctamente.',
			101: 'Al menos una receta presentó inconvenientes. Si ya fue regularizado por el cliente, aprobá la orden para continuar.',
			2: `La orden fue aprobada. Si necesitas realizar algún cambio, puedes hacerlo desde aquí o continuar.`,
			201: 'Verifica que cuentes con todos los productos que contiene la orden. Si necesitas anular algún producto o la totalidad de la orden, puedes hacerlo desde aquí o continuar.',
			3: 'La orden fue confirmada y ya puedes empacar el pedido. En cuanto esté listo, dale a continuar.',
			4: `${
				typeDelivery === typeRetirement[Enviroment.LANGUAGE].home
					? 'El pedido ya fue armado y está listo para ser retirado por el mensajero. Cuando el cliente reciba el pedido confirma la entrega.'
					: 'El pedido ya fue armado y está listo para ser retirado por el cliente. Cuando el cliente retire el pedido confirma la entrega.'
			}`,
			5: `El pedido ya fue entregado al mensajero y se encuentra en camino al domicilio del cliente.`,
			6: `${
				typeDelivery === typeRetirement[Enviroment.LANGUAGE].home
					? 'El pedido fue entregado en el domicilio del cliente.'
					: 'El pedido fue entregado al cliente en la farmacia.'
			}`,
			8: `${
				checkStatusReverse(products)
					? 'El pedido fue anulado. En caso de ser necesario puedes revertir la anulación'
					: 'El pedido fue anulado. Esta orden no tiene productos, no se puede revertir la anulación de la orden.'
			}`,
			9: 'El cliente ha confirmado la entrega/recepción del pedido.',
		},
		CLZUPHARMA: {
			1: 'Antes de aprobar la orden y continuar, verifica la receta. Podés rechazarla en caso de error y solicitar que se reenvíe correctamente.',
			101: 'Al menos una receta presentó inconvenientes. Si ya fue regularizado por el cliente, aprobá la orden para continuar.',
			2: `La orden fue aprobada. Si necesitas realizar algún cambio, puedes hacerlo desde aquí o continuar.`,
			201: 'Verifica que cuentes con todos los productos que contiene la orden. Si necesitas anular algún producto o la totalidad de la orden, puedes hacerlo desde aquí o continuar.',
			3: 'La orden fue confirmada y ya puedes empacar el pedido. En cuanto esté listo, dale a continuar.',
			4: `${
				typeDelivery === typeRetirement[Enviroment.LANGUAGE].home
					? 'El pedido ya fue armado y está listo para ser retirado por el mensajero. Cuando el cliente reciba el pedido confirma la entrega.'
					: 'El pedido ya fue armado y está listo para ser retirado por el cliente. Cuando el cliente retire el pedido confirma la entrega.'
			}`,
			5: `El pedido ya fue entregado al mensajero y se encuentra en camino al domicilio del cliente.`,
			6: `${
				typeDelivery === typeRetirement[Enviroment.LANGUAGE].home
					? 'El pedido fue entregado en el domicilio del cliente.'
					: 'El pedido fue entregado al cliente en la farmacia.'
			}`,
			8: `${
				checkStatusReverse(products)
					? 'El pedido fue anulado. En caso de ser necesario puedes revertir la anulación'
					: 'El pedido fue anulado. Esta orden no tiene productos, no se puede revertir la anulación de la orden.'
			}`,
			9: 'El cliente ha confirmado la entrega/recepción del pedido.',
		},
		MX: {
			1: 'Antes de aprobar la orden y continuar, verifica la receta. Podés rechazarla en caso de error y solicitar que se reenvíe correctamente.',
			101: 'Al menos una receta presentó inconvenientes. Si ya fue regularizado por el cliente, aprobá la orden para continuar.',
			2: `La orden fue aprobada. Si necesitas realizar algún cambio, puedes hacerlo desde aquí o continuar.`,
			201: 'Verifica que cuentes con todos los productos que contiene la orden. Si necesitas anular algún producto o la totalidad de la orden, puedes hacerlo desde aquí o continuar.',
			3: 'La orden fue confirmada y ya puedes empacar el pedido. En cuanto esté listo, dale a continuar.',
			4: `${
				typeDelivery === typeRetirement[Enviroment.LANGUAGE].home
					? 'El pedido ya fue armado y está listo para ser retirado por el mensajero.'
					: 'El pedido ya fue armado y está listo para ser retirado por el cliente. Cuando el cliente retire el pedido confirma la entrega.'
			}`,
			5: `El pedido ya fue entregado al mensajero y se encuentra en camino al domicilio del cliente.`,
			6: `${
				typeDelivery === typeRetirement[Enviroment.LANGUAGE].home
					? 'El pedido fue entregado en el domicilio del cliente.'
					: 'El pedido fue entregado al cliente en la farmacia.'
			}`,
			8: `${
				checkStatusReverse(products)
					? 'El pedido fue anulado. En caso de ser necesario puedes revertir la anulación'
					: 'El pedido fue anulado. Esta orden no tiene productos, no se puede revertir la anulación de la orden.'
			}`,
			9: 'El cliente ha confirmado la entrega/recepción del pedido.',
		},
	};
};
